
<template>
  <div>
    <b-button
      v-permission="'contacts.create'"
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      @click="addNew"
    >
      <feather-icon
        icon="PlusIcon"
        class="mr-50"
      />
      <span class="align-middle">{{$t('AddNew')}}</span>
    </b-button>

    <Grid :service="service" route_name="contacts">
      <template #actions="actions">
        <feather-icon
          v-permission="`contacts.edit`"
          icon="EditIcon"
          class="h-5 w-5 mb-1 mr-1 stroke-current text-warning"
          v-if="!hide_edit"
          @click="actions.methods.edit(actions.data[actions.indextr].id)"
        />
        <feather-icon
          v-permission="`contacts.delete`"
          icon="Trash2Icon"
          class="h-5 w-5 mb-1 mr-1 stroke-current text-danger"
          v-if="!hide_delete"
          @click="actions.methods.destroy(actions.data[actions.indextr])"
        />
      </template>
    </Grid>
  </div>
</template>


<script>
import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

import ContactService from '@/services/api/ContactService'

export default {
  directives: {
    Ripple,
  },
  components: {
    BButton,
  },
  data: () => ({
    selected: [],
    service: null
  }),
  methods: {
    addNew() {
      this.$router.push('/contacts/create')
    }
  },
  beforeMount() {
    this.service = ContactService.build(this.$vs)
  }
}
</script>